import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { baseUrl, apiHelper } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';

export default function Form(props) {
    const [ enteredMobileNumber, setEnteredMobileNumber ] = useState('');
    const [ enteredOTP, setEnteredOTP ] = useState('');
    const [ isOTPSent, setIsOTPSent ] = useState(false);
    const [ isSendingOTP, setIsSendingOTP ] = useState(false);
    const [ isVerifying, setIsVerifying ] = useState(false);
    const [ hmac, setHmac ] = useState(null);
    const [ qrCodeLink, setQrCodeLink ] = useState(null);

    const onClickSearch = function() {
        if (enteredMobileNumber.length !== 10) {
            notify.error({ "description": "Invalid Mobile Number" })
            return;
        }
        const apiParams = { 'mobile_number': enteredMobileNumber }
        setIsSendingOTP(true);
        let apiUrl = `${baseUrl}/.netlify/functions/otp_verification`;
        let apiPromise = apiHelper.get({ "url": apiUrl, "params": apiParams })

        apiPromise
        .then(response => {
            if (response.status) {
                setHmac(response.json.hmac);
                setIsOTPSent(true);
            } else { console.log(response.json); }
            setIsSendingOTP(false);
        })
    }

    const onClickVerify = function() {
        const data = { 'mobile_number': enteredMobileNumber, 'otp': enteredOTP,
            'hmac': hmac }
        setIsVerifying(true);
        let apiUrl = `${baseUrl}/.netlify/functions/otp_verification`;
        let apiPromise = apiHelper.post({ "url": apiUrl, "data": data })

        apiPromise
        .then(response => {
            if (response.status) {
                setQrCodeLink(response.json.qr_code_link);
                localStorage.setItem("qr_code_link", response.json.qr_code_link);
                console.log(response.json.qr_code_link)
            } else {
                console.log(response.json);
                notify.error({ "description": response.json.message })
            }
            setIsVerifying(false);
        })
    }

    const onClickDownload = function() {
        var img = document.getElementById("qr-code-img");
        if (!img.complete || img.naturalHeight == 0) {
            notify.info({ "description": "QR Code not loaded yet. Please wait" })
            return;
        }

        const canvasElem = document.createElement("canvas");
        var ctx = canvasElem.getContext("2d");
        ctx.scale(1, 1);
        canvasElem.width = img.offsetWidth;
        canvasElem.height = img.offsetHeight;
        ctx.drawImage(img, 0, 0);

        var image = canvasElem.toDataURL("image/png").replace("image/png", "image/octet-stream");
        const a = document.createElement("a");
        a.href = image;
        a.download = "my-qr-code.png";
        a.click();
    }

    const onClickReset = function() {
        localStorage.clear();
        setEnteredMobileNumber('');
        setEnteredOTP('');
        setIsOTPSent(false);
        setHmac(null);
        setQrCodeLink(null);
    }

    useEffect(function() {
        if (localStorage.getItem('qr_code_link')) {
            setIsOTPSent(true);
            setQrCodeLink(localStorage.getItem('qr_code_link'));
        }
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                width: '100%' }}>
                <SmallHeading>Download your QR Code</SmallHeading>
                <TextField label="Enter Mobile Number"
                    sx={{ width: '100%', marginTop: '15px' }}
                    onChange={(e) => { setEnteredMobileNumber(e.target.value); }}
                    value={enteredMobileNumber} inputProps={{ maxLength: 10 }}
                 />

                { !isOTPSent && (isSendingOTP ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                    <Button sx={{ marginTop: '15px' }} onClick={() => onClickSearch()}
                        variant="outlined">Send OTP</Button>)
                }
                { !qrCodeLink && isOTPSent && 
                    <>
                        <TextField label="Enter OTP"
                            sx={{ width: '100%', marginTop: '15px' }}
                            onChange={(e) => { setEnteredOTP(e.target.value); }}
                            value={enteredOTP} />
                        { isVerifying ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                            <Button sx={{ marginTop: '15px' }} onClick={() => onClickVerify()}
                                variant="outlined">Verify and Download</Button>
                        }
                    </>
                }
                {qrCodeLink && 
                    <>
                    <img id="qr-code-img" crossOrigin="anonymous"
                        style={{ marginTop: '15px' }} src={qrCodeLink}/>
                    <Box>
                        <Button sx={{ marginTop: '15px', marginRight: '5px' }} onClick={() => onClickDownload()}
                            variant="outlined">Download</Button>
                        <Button sx={{ marginTop: '15px', marginLeft: '5px' }} onClick={() => onClickReset()}
                            variant="outlined">Reset</Button>
                    </Box>
                    </>
                }
            </ColumnBox>
        </Box>
    );
}
